import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { BATCH_LOG_CONFIG } from './base/batch-log-config';

/**
 * BatchLog Feature Routes
 *
 * 읽기 전용 도메인:
 * - List Page: /paywith-master/batch-log/list
 * - Detail Page: /paywith-master/batch-log/list/:id
 * - Redirect: /paywith-master/batch-log → /paywith-master/batch-log/list
 */
export const batchLogRoutes: Routes = [
  {
    path: BATCH_LOG_CONFIG.routePath, // 'paywith-master/batch-log'
    canActivate: [roleGuard('ADMIN_SYSTEM')],
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
      },
      {
        path: 'list',
        loadComponent: () =>
          import(
            './components/smart/batch-log-list-page/batch-log-list-page.component'
          ).then((m) => m.BatchLogListPageComponent),
        canActivate: [roleGuard('ADMIN_SYSTEM')],
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import(
                './components/smart/batch-log-detail-page/batch-log-detail-page.component'
              ).then((m) => m.BatchLogDetailPageComponent),
          },
        ],
      },
    ],
  },
];
